import React, { useState, useEffect } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

function BookATour() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Disable scrolling on modal
  useEffect(() => {
    document.body.style.overflow = modalIsOpen ? "hidden" : "auto";
  }, [modalIsOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();

    setModalIsOpen(true);

    // Reset form fields
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  return (
    <div
      className="space-extra2-top space-extra2-bottom"
      style={{
        backgroundColor: "#0e1b2c",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        padding: "60px 20px",
      }}
    >
      <div className="container">
        <div className="row flex-row-reverse justify-content-center align-items-center">
          <div className="col-lg-6">
            <form className="contact-form style2" onSubmit={handleSubmit}>
              <h3 className="sec-title mb-30 text-capitalize">Get In Touch</h3>

              <div className="row">
                <div className="col-12 form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Full Name"
                    required
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <img src="/assets/img/icon/user.svg" alt="" />
                </div>

                <div className="col-12 form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email Address"
                    required
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <img src="/assets/img/icon/mail.svg" alt="" />
                </div>

                <div className="form-group col-12">
                  <textarea
                    rows={3}
                    className="form-control"
                    placeholder="Message"
                    value={formData.message}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                  />
                  <img src="/assets/img/icon/chat.svg" alt="" />
                </div>

                <div className="form-btn col-12 mt-24">
                  <button type="submit" className="th-btn style3">
                    Send Message
                    <img src="/assets/img/icon/plane.svg" alt="" />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* SUCCESS MODAL */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        className="success-modal"
        overlayClassName="success-modal-overlay"
      >
        <h2 style={{ fontSize: "28px", marginBottom: "10px" }}>
          🎉 Thank You!
        </h2>
        <p style={{ color: "#555" }}>
          We received your message. Our team will reach out shortly.
        </p>

        <button
          className="close-btn-action"
          onClick={() => setModalIsOpen(false)}
        >
          Close
        </button>
      </Modal>

      {/* CSS */}
      <style>{`
        .form-control {
          width: 100%;
          padding: 14px;
          border-radius: 10px;
          border: 1px solid #ddd;
          font-size: 15px;
          padding-left: 40px;
        }

        .form-group {
          position: relative;
          margin-bottom: 18px;
        }

        .form-group img {
          position: absolute;
          left: 20px;
          top: 50%;
          width: 18px;
          height: 18px;
          transform: translateY(-50%);
          opacity: 0.6;
        }

        .th-btn.style3 {
          background: #0b61d6;
          padding: 12px 24px;
          border-radius: 10px;
          color: white;
          font-weight: 600;
          transition: .2s;
          border: none;
        }

        .th-btn.style3:hover {
          background: #084db1;
        }

        .success-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .success-modal {
          background: white;
          padding: 35px;
          border-radius: 14px;
          width: 420px;
          max-width: 90%;
          text-align: center;
          animation: fadeIn .25s ease;
        }

        @keyframes fadeIn {
          from { transform: scale(.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        .close-btn-action {
          margin-top: 20px;
          background: #0b61d6;
          border:none;
          color:white;
          padding:10px 18px;
          border-radius:8px;
          cursor:pointer;
          font-weight:600;
          transition: .2s ease;
        }

        .close-btn-action:hover {
          background:#084db1;
        }
      `}</style>
    </div>
  );
}

export default BookATour;
